export const testData = {
    statusCode: '200',
    message: '성공',
    data: {
        diagnosticInfo: { participantName: 'name26', academyCode: 'AA000000', kreadScore: 0, schoolGrade: '학생', completeDate: '2023-02-27', participantCode: '61713', correctCount: 24, accuracyRate: 66, elapsedTime: 12, level: 1, lesson: 1 },
        commentDiagnosticResult:
            ' name26학생의 독해능력은 66% 이며, 비문학의 성취가 전반적으로 높게 나타났습니다. 지문별로 살펴보면, 문학에서는 현대소설, 극수필의 성취가 가장 낮았습니다. 비문학에서는 인문, 예술, 정치사회, 경제문화, 과학, 기술의 성취가 가장 뛰어났습니다.\n 문항별로 살펴보면, 글 전체 이해를 묻는 질문, 추론적 독해, 비판적 독해의 문제 해결력은 우수하나, 글 부분 이해를 묻는 질문, 개념 유형에 취약합니다. 자신의 강점을 살리고 약점을 보완하는 체계적인 독해 트레이닝 학습을 통해 독해 자신감과 수능 실전 감각을 키워 보세요.',
        commentMyKread:
            ' name26 학생의 KReaD 지수는 0으로, 학생 수준의 글을 능숙하게 읽을 수 있는 정도입니다. KReaD 역량을 키우려면 자신의 KReaD 지수에 맞는 글만 골라 읽는 것보다는, KReaD 지수가 조금 낮거나 높은 수준에서 다양한 분야의 글을 골고루 접하는 것이 중요합니다.',
        commentStartPoint:
            ' name26 학생의 학습 출발점은 1레벨 1레슨 입니다.\n 다만 지문별 성취도의 격차를 줄이고, 부족한 문항 영역을 트레이닝하기 위해  지문 12개 레슨을 먼저 학습하는 것을 추천합니다. 추천 학습대로 학습 시 문제 풀이에 대한 자신감이 생기고, 지문별 실력 편차가 줄어들어 차후 균형 있는 학습이 가능해집니다.',
        commentTopic: ' 문학에서는 현대소설, 극수필의 성취가 가장 낮았습니다.\n 비문학에서는 인문, 예술, 정치사회, 경제문화, 과학, 기술의 성취가 가장 뛰어났습니다.',
        topicResult: { passage01: 66, passage02: 33, passage03: 33, passage04: 0, passage05: 0, passage06: 100, passage07: 100, passage08: 100, passage09: 100, passage10: 100, passage11: 100, passage12: 66 },
        commentAnalysis: ' 개념의 성취도가 낮게 나타났습니다.',
        analysisResult: { analysis5080: 0, analysis5078: 85, analysis5079: 85, analysis5085: 60, analysis5077: 60, analysis5081: 54 },
        commentProblemType: ' 글 부분 이해를 묻는 질문을 어려워한 것으로 나타났습니다.',
        problemTypeResult: { typenegative: 66, typeall: 80, typepart: 46, typepositive: 66, typeoptionexist: 66, typeoptionnone: 66 },
        literatureResult: [
            {
                passageSeq: 417,
                passageName: '떨어져도 튀는 공처럼',
                topic: '현대시',
                kreadScore: '1350',
                elapsedTime: 110,
                solveTime: 180,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1348, analysisName: '추론적 독해', learningConceptName: '작품의 내용 이해', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1349, analysisName: '감상적 독해', learningConceptName: '화자의 태도 및 정서 파악', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1350, analysisName: '어휘', learningConceptName: '문맥적 의미의 유사성 판단', correctYn: 0 },
                ],
            },
            {
                passageSeq: 420,
                passageName: '하여가, 단심가',
                topic: '고전시가: 시조',
                kreadScore: '1350',
                elapsedTime: 6,
                solveTime: 180,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1351, analysisName: '추론적 독해', learningConceptName: '시적 상황과 화자의 정서 파악', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1352, analysisName: '감상적 독해', learningConceptName: '자료를 활용한 감상', correctYn: 0 },
                    { diagnosticAnswerHistorySeq: 1353, analysisName: '어휘', learningConceptName: '문맥적 의미 이해', correctYn: 0 },
                ],
            },
            {
                passageSeq: 419,
                passageName: '토끼전',
                topic: '고전산문: 고전 소설',
                kreadScore: '1350',
                elapsedTime: 6,
                solveTime: 394,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1354, analysisName: '사실적 독해', learningConceptName: '구절의 의미 이해', correctYn: 0 },
                    { diagnosticAnswerHistorySeq: 1355, analysisName: '비판적 독해', learningConceptName: '인물에 대한 평가', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1356, analysisName: '개념', learningConceptName: '갈래의 특징을 반영한 작품 이해', correctYn: 0 },
                ],
            },
            {
                passageSeq: 641,
                passageName: '줄',
                topic: '현대소설',
                kreadScore: '1302',
                elapsedTime: 493,
                solveTime: 268,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1357, analysisName: '추론적 독해', learningConceptName: '인물의 심리', correctYn: 0 },
                    { diagnosticAnswerHistorySeq: 1358, analysisName: '감상적 독해', learningConceptName: '구절의 의미와 기능 파악', correctYn: 0 },
                    { diagnosticAnswerHistorySeq: 1359, analysisName: '어휘', learningConceptName: '문맥적 의미의 유사성 판단', correctYn: 0 },
                ],
            },
            {
                passageSeq: 653,
                passageName: '거짓말은 이제 그만',
                topic: '극수필: 희곡',
                kreadScore: '1261',
                elapsedTime: 7,
                solveTime: 310,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1360, analysisName: '사실적 독해', learningConceptName: '대화의 상황과 의도', correctYn: 0 },
                    { diagnosticAnswerHistorySeq: 1361, analysisName: '비판적 독해', learningConceptName: '장면에 사용된 기법 이해', correctYn: 0 },
                    { diagnosticAnswerHistorySeq: 1362, analysisName: '어휘', learningConceptName: '바꿔 쓰기에 적절한 어휘', correctYn: 0 },
                ],
            },
        ],
        nonLiteratureResult: [
            {
                passageSeq: 680,
                passageName: '포함하는 낱말, 포함되는 낱말, 뜻이 비슷한 낱말',
                topic: '인문: 논리/심리/인지/감성/언어',
                kreadScore: '1201',
                elapsedTime: 7,
                solveTime: 239,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1363, analysisName: '추론적 독해', learningConceptName: '글의 중심 화제 파악', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1364, analysisName: '비판적 독해', learningConceptName: '세부 정보 확인', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1365, analysisName: '어휘', learningConceptName: '어구의 의미 관계', correctYn: 1 },
                ],
            },
            {
                passageSeq: 704,
                passageName: '옛그림 읽기의 즐거움',
                topic: '예술: 예술일반/미술/미학/서예_동양',
                kreadScore: '1289',
                elapsedTime: 11,
                solveTime: 245,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1366, analysisName: '사실적 독해', learningConceptName: '세부 정보 추론', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1367, analysisName: '비판적 독해', learningConceptName: '반응의 적절성 평가', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1368, analysisName: '어휘', learningConceptName: '문맥적 의미의 유사성 판단', correctYn: 1 },
                ],
            },
            {
                passageSeq: 720,
                passageName: '물 부족 현상에 대비해야 한다',
                topic: '정치사회: 행정/정책',
                kreadScore: '1309',
                elapsedTime: 9,
                solveTime: 335,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1369, analysisName: '추론적 독해', learningConceptName: '개괄적 내용 추론', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1370, analysisName: '감상적 독해', learningConceptName: '다른 사례에의 적용', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1371, analysisName: '어휘', learningConceptName: '사전적 의미 이해', correctYn: 1 },
                ],
            },
            {
                passageSeq: 744,
                passageName: '독도에는 무엇이 있을까',
                topic: '경제문화: 지리/도시/지역',
                kreadScore: '1392',
                elapsedTime: 14,
                solveTime: 274,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1372, analysisName: '사실적 독해', learningConceptName: '글의 중심 화제 파악', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1373, analysisName: '비판적 독해', learningConceptName: '내용 이해의 적절성 평가', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1374, analysisName: '어휘', learningConceptName: '문맥적 의미의 유사성 판단', correctYn: 1 },
                ],
            },
            {
                passageSeq: 762,
                passageName: '빛의 여행',
                topic: '과학: 물리',
                kreadScore: '1407',
                elapsedTime: 16,
                solveTime: 351,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1375, analysisName: '사실적 독해', learningConceptName: '세부 정보 확인', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1376, analysisName: '비판적 독해', learningConceptName: '특정 관점에서의 비판', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1377, analysisName: '어휘', learningConceptName: '상황에 알맞은 한자 성어', correctYn: 1 },
                ],
            },
            {
                passageSeq: 775,
                passageName: '재생 가능한 태양 에너지',
                topic: '기술: 에너지/자원/원자력/환경/화공',
                kreadScore: '1494',
                elapsedTime: 54,
                solveTime: 294,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1378, analysisName: '추론적 독해', learningConceptName: '품사의 종류와 특성', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1379, analysisName: '감상적 독해', learningConceptName: '반응의 적절성 평가', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1380, analysisName: '어휘', learningConceptName: '바꿔 쓰기에 적절한 어휘', correctYn: 1 },
                ],
            },
            {
                passageSeq: 785,
                passageName: '바나나킥의 원리',
                topic: '융합: 과학+',
                kreadScore: '1514',
                elapsedTime: 37,
                solveTime: 302,
                problemResultList: [
                    { diagnosticAnswerHistorySeq: 1381, analysisName: '추론적 독해', learningConceptName: '개괄적 정보 확인', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1382, analysisName: '비판적 독해', learningConceptName: '구체적 상황에의 적용', correctYn: 1 },
                    { diagnosticAnswerHistorySeq: 1383, analysisName: '어휘', learningConceptName: '문맥적 의미의 유사성 판단', correctYn: 0 },
                ],
            },
        ],
    },
};
